<template>
  <List :mcs-service-no="2" />
</template>

<script>
import '@telexpress_auth/vue-gss/dist/components/List.css';
import List from '@telexpress_auth/vue-gss/dist/components/List.umd.min';

export default {
  components: {
    List,
  },

};
</script>
